import { createContext, useContext } from "react";


const tidContext = createContext<string | undefined>(undefined);

export const TenantInstallationIdProvider = tidContext.Provider;


const useTenantInstallationId = (throwIfMissing = true) => {
  const tiid = useContext(tidContext);
  if (!tiid && throwIfMissing) {
    throw new Error("No Tenant-Installation-Id available!")
  }

  return tiid;
}

export default useTenantInstallationId;


